namespace RioERP.Masters {
    export interface AllowedDevicesForm {
        Device: Serenity.StringEditor;
    }

    export class AllowedDevicesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.AllowedDevices';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AllowedDevicesForm.init)  {
                AllowedDevicesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(AllowedDevicesForm, [
                    'Device', w0
                ]);
            }
        }
    }
}
